
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/help/shipping-returns",
      function () {
        return require("private-next-pages/help/shipping-returns/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/help/shipping-returns"])
      });
    }
  